/* ==========================================================================
   NS Dynamic Grid
   Hydrates ns-product-grid sections whose source is "recommendations" or
   "recently_viewed". Both render empty server-side, then this refetches the
   section through Shopify's Section Rendering API and swaps the markup in.
   ========================================================================== */
(function () {
  'use strict';

  var RV_KEY = 'ns:recently-viewed';

  function readRecentlyViewed() {
    try {
      var raw = localStorage.getItem(RV_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function swapIn(root, html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh =
      doc.getElementById('shopify-section-' + sectionId) ||
      doc.querySelector('[data-ns-dynamic-grid]');
    if (!fresh) {
      hide(root);
      return;
    }

    var cards = fresh.querySelectorAll('.ns-pcard a, .ns-pcard');
    if (!cards.length) {
      hide(root);
      return;
    }

    var inner = fresh.querySelector('[data-ns-dynamic-grid]') || fresh;
    root.innerHTML = inner.innerHTML;
    root.classList.remove('ns-section--deferred');

    // let the theme's reveal/carousel code pick up the new nodes
    document.dispatchEvent(new CustomEvent('ns:section:loaded', { detail: { section: root } }));
  }

  function hide(root) {
    var wrapper = root.closest('.shopify-section') || root;
    wrapper.style.display = 'none';
  }

  function hydrate(root) {
    var source = root.getAttribute('data-ns-source');
    var sectionId = root.getAttribute('data-ns-section-id');
    var limit = parseInt(root.getAttribute('data-ns-limit'), 10) || 8;
    var url;

    if (source === 'recommendations') {
      var productId = root.getAttribute('data-ns-product-id');
      if (!productId) {
        hide(root);
        return;
      }
      var intent = root.getAttribute('data-ns-intent') || 'related';
      url =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      url =
        url +
        'recommendations/products?section_id=' +
        encodeURIComponent(sectionId) +
        '&product_id=' +
        encodeURIComponent(productId) +
        '&limit=' +
        limit +
        '&intent=' +
        encodeURIComponent(intent);
    } else if (source === 'recently_viewed') {
      var ids = readRecentlyViewed();
      var current = document.querySelector('[data-ns-product-id]');
      var currentId = current ? current.getAttribute('data-ns-product-id') : null;
      if (currentId) {
        ids = ids.filter(function (id) {
          return String(id) !== String(currentId);
        });
      }
      ids = ids.slice(0, limit);
      if (!ids.length) {
        hide(root);
        return;
      }
      var q = ids
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ');
      url =
        '/search?section_id=' +
        encodeURIComponent(sectionId) +
        '&type=product&q=' +
        encodeURIComponent(q);
    } else {
      return;
    }

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        swapIn(root, html, sectionId);
      })
      .catch(function () {
        hide(root);
      });
  }

  function init() {
    var roots = document.querySelectorAll('[data-ns-dynamic-grid]');
    if (!roots.length) return;

    // only fetch when the section is close to the viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            hydrate(entry.target);
          });
        },
        { rootMargin: '400px 0px' }
      );
      roots.forEach(function (el) {
        io.observe(el);
      });
    } else {
      roots.forEach(hydrate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
